import React from 'react';
import { NotFound } from 'components/views/organisms/NotFound';

export const NotFoundPage = () => {
    return (
        <NotFound />
    );
};
